import React, { Component } from 'react'
import styles from './styles.scss'

import { TimelineMax, TweenMax, Power3, Cubic } from 'gsap'

import Cover from 'src/components/cover-img'

import resize from 'src/utils/resize'
import values from 'src/values'

export default class ImgItem extends Component {
  constructor(props) {
    super(props)

    this.sizes = {
      desktop: { w: 300, h: 300 }
    }

    this.key = `imgItem${Math.random()}`
  }

  componentDidMount() {
    this.initTL()
    this.onResize()

    resize.add(this.onResize, this.key)
  }

  componentWillUnMount() {
    resize.remove(this.onResize)
  }

  initTL() {
    this.tlAnimateInOverlay = new TimelineMax({
      paused: true
    })

    this.tlAnimateInOverlay
      .to(
        this.refs.itemContainer,
        0.6,
        {
          autoAlpha: 1,
          ease: Power3.easeOut
        },
        0
      )
      .staggerFromTo(
        [this.refs.title, this.refs.content],
        0.6,
        {
          y: 25,
          opacity: 0
        },
        {
          y: 0,
          opacity: 1,
          ease: Power3.easeOut,
          delay: 0.05
        },
        0.05,
        0
      )
  }

  resetTL() {
    this.tlAnimateInIsPlaying = false
    this.tlAnimateInIsEnded = false
    this.tlAnimateIn.pause()
    this.tlAnimateIn.progress(0)
  }

  onResize = () => {
    if (!this.refs.component) return
    const $component = this.refs.component.getBoundingClientRect()
    this.topComponent = $component.top + values.scroll.currentY
    this.leftComponent = $component.left

    const $img = this.refs.imgContainer.getBoundingClientRect()
    this.topImg = $img.top + values.scroll.currentY
    this.leftImg = this.props.sizes.w * this.props.column

    this.hComponent = this.refs.component.offsetHeight
    this.wComponent = this.refs.component.offsetWidth
  }

  onMouseEnter = () => {
    this.tlAnimateInOverlay.timeScale(1).play(0)
    TweenMax.to(this.refs.mainWrapper, 0.6, {
      z: 20,
      ease: Power3.easeOut
    })
  }

  onMouseLeave = () => {
    this.tlAnimateInOverlay.timeScale(2).reverse()
    TweenMax.to(this.refs.mainWrapper, 0.4, {
      rotationX: 0,
      rotationY: 0,
      z: 1,
      ease: Power3.easeOut
    })
  }

  splitter(str, l) {
    return `${str.substring(0, l)}...`
  }

  onClick = () => {
    window.open(this.props.data.full_url, '_blank')
  }

  render() {
    const { image, message, poster_name } = this.props.data

    return (
      <div
        ref="component"
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
        onClick={this.onClick}
        className="component img-item"
        style={{ width: this.props.sizes.w, height: this.props.sizes.h }}>
        <div ref="mainWrapper" className="img-item-container">
          <div ref="itemContainer" className="content-item-container">
            <img
              className="insta"
              src={`${process.env.PUBLIC_URL}/img/insta-white.png`}
            />
            <p ref="title" className="btn">
              {poster_name}
            </p>
            <p
              ref="content"
              className="content"
              dangerouslySetInnerHTML={{ __html: this.splitter(message, 80) }}
            />
          </div>
          <div ref="imgContainer" className="img-container">
            <img
              className="insta"
              src={`${process.env.PUBLIC_URL}/img/insta.png`}
            />
            <Cover ref="cover" src={image} />
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Home/components/wall/components/wall-wrapper/components/img-item/index.js